//React
import { useEffect, useState } from 'react';
//API
import { AccountApi, DistributorApi } from '../../apis/index';
//Material-UI
import ApartmentIcon from '@mui/icons-material/Apartment';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
//Components
import InfinityScroll from '../../components/InfinityScroll.js';
import MyCircularProgress from '../../components/Circleprogess.js';
//lodash
import { throttle } from 'lodash';
//dayjs
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/ko';

const DistributorAdminList = (props) => {
  const [accounts, setAccounts] = useState([]);

  const [search, setSearch] = useState(false);
  const [searchEnd, setSearchEnd] = useState(true);
  const [loading, setLoading] = useState(false);

  const [count, setCount] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [selectValue, setSelectValue] = useState('Name');

  useEffect(() => {
    firstLoad();
  }, []);

  useEffect(() => {
    if (searchEnd) {
      if (count >= 1 && !search) {
        loadData();
      }
      if (count >= 1 && search) {
        loadsearchData();
      }
    }
  }, [count]);
  dayjs.extend(relativeTime);
  dayjs.locale('en');

  const loadDataCommon = async (isSearch, value, pageCount = 0) => {
    setLoading(false);

    let res;

    if (isSearch) {
      if (selectValue === 'Name') {
        res = await DistributorApi.getSearchAccountNameList(value, pageCount);
      } else {
        res = await DistributorApi.getSearchAccountEmailList(value, pageCount);
      }
    } else {
      res = await DistributorApi.getAccountList(pageCount);
    }
    const transformedData = res.data.content.map((account) => ({
      data1: { key: 'ID', value: account.memberId },
      data2: { key: 'Hospital Name', value: account.hospitalName },
      data3: { key: 'Email', value: account.email },
      data4: {
        key: 'Role',
        value: account.memberType ? account.memberType.join(', ') : '',
      },
      data5: {
        key: 'Status',
        value: account.memberStatus,
      },
      data6: {
        key: '접속일',
        // modifyDate를 상대 시간으로 변환
        value: dayjs(account.modifyDate).fromNow(),
      },
    }));

    setAccounts((prev) =>
      pageCount === 0 ? transformedData : [...prev, ...transformedData],
    );

    if (res.data.numberOfElements !== 15) {
      setLoading(true);
      setSearchEnd(false);
    } else {
      setLoading(false);
    }
  };

  const firstLoad = async () => {
    await loadDataCommon(false);
  };

  const loadData = async () => {
    await loadDataCommon(false, null, count);
  };

  const loadFirstsearchData = async (value) => {
    setCount(0);
    setAccounts([]);
    setSearch(true);
    const searchValueToUse = value || searchValue;
    await loadDataCommon(true, searchValueToUse, 0);
  };

  const loadsearchData = async (value) => {
    setSearch(true);
    const searchValueToUse = value || searchValue;
    await loadDataCommon(true, searchValueToUse, count);
  };

  const handleChangeValue = (e) => {
    if (e.key === 'Enter' && e.target.value.toString().length !== 0) {
      const value = e.target.value.toString().trim();
      setCount(0);
      setSearchEnd(true);
      setAccounts([]);
      setSearch(true);
      setSearchValue(value);
      loadFirstsearchData(value);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
    if (e.key === 'Enter' && e.target.value.toString().length === 0) {
      setCount(0);
      setSearchEnd(true);
      setSearch(false);
      firstLoad();
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  };

  const handleChangeValueClick = () => {
    if (searchValue.toString().length !== 0) {
      setCount(0);
      setSearchEnd(true);
      setAccounts([]);
      setSearch(true);
      setSearchValue(searchValue);
      loadFirstsearchData(searchValue);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
    if (searchValue.toString().length === 0) {
      setCount(0);
      setSearchEnd(true);
      setSearch(false);
      firstLoad();
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  };

  const hadlesearchValue = (e) => {
    setSearchValue(e.target.value);
  };

  const handleRadioChange = (event) => {
    setSelectValue(event.target.value);
  };

  const loadMoreItems = async () => {
    setCount((prevCount) => prevCount + 1);
    if (!searchEnd) {
      setLoading(false);
    }
  };

  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const scrollHeight = document.documentElement.scrollHeight;
    const isAtBottom = scrollTop + windowHeight >= scrollHeight - 34;

    if (isAtBottom) {
      loadMoreItems();
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', throttle(handleScroll, 1000));
    return () =>
      window.removeEventListener('scroll', throttle(handleScroll, 1000));
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleRowSelection = (e) => {
    props.history.push('/updatedistributorAdmin/' + e);
  };

  return (
    <>
      <InfinityScroll
        title="DISTIBUTOR LIST"
        saveIcon={
          <ApartmentIcon
            style={{
              color: 'rgb(63, 89, 140)',
              opacity: '90%',
            }}
          />
        }
        saveLink="/saveDistributorAdmin"
        saveName="NEW DISTRIBUTOR"
        searchPlaceholder={
          selectValue == 'Name' ? 'Enter name...' : 'Enter email...'
        }
        handleChangeValue={handleChangeValue}
        searchValue={searchValue}
        hadlesearchValue={hadlesearchValue}
        handleChangeValueClick={handleChangeValueClick}
        selectedValue={selectValue}
        onChange={handleRadioChange}
        row={accounts}
        column={[
          { key: 'ID', value: 'ID', width: '100' },
          { key: 'Hospital Name', value: 'Hospital Name', width: '180' },
          { key: 'Email', value: 'Email', width: '270' },
          { key: 'Role', value: 'Role', width: '320' },
          { key: 'Status', value: 'Status', width: '115' },
          { key: 'Last Login', value: 'Last Login', width: '120' },
        ]}
        handleRowSelection={handleRowSelection}
        searchFlag={true}
      />

      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          marginTop: '20px',
        }}
      >
        {!loading ? <MyCircularProgress /> : <></>}
      </div>
      <div
        style={{
          position: 'fixed',
          bottom: '100px',
          right: '40px',
          width: '30px',
          height: '30px',
          backgroundColor: '#FFFFFF',
          borderRadius: '50%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ExpandCircleDownIcon
          onClick={scrollToTop}
          style={{
            fontSize: '50px',
            color: '#3F598C',
            transform: 'rotate(180deg)',
          }}
        />
      </div>
    </>
  );
};

export default DistributorAdminList;
